import { Chip, Grid } from "@mui/material";
import { getFullName } from "../../utils/helpers";

const PersonalInfoTab = ({ user }) => {
  return (
    <div className="space-y-6">
      <Grid container spacing={4}>
        <Grid size={{ xs: 12, md: 6 }}>
          <h3 className="text-lg font-semibold mb-4 text-secondary-900">
            Basic Information
          </h3>
          <div className="space-y-4">
            <div className="flex justify-between py-2 border-b">
              <span className="text-secondary-600">Full Name</span>
              <span className="font-medium">
                {user.full_name ||
                  getFullName(user.first_name, user.last_name) ||
                  "Not provided"}
              </span>
            </div>
            <div className="flex justify-between py-2 border-b">
              <span className="text-secondary-600">First Name</span>
              <span className="font-medium">
                {user.first_name || "Not provided"}
              </span>
            </div>
            <div className="flex justify-between py-2 border-b">
              <span className="text-secondary-600">Last Name</span>
              <span className="font-medium">
                {user.last_name || "Not provided"}
              </span>
            </div>
            <div className="flex justify-between py-2 border-b">
              <span className="text-secondary-600">Email Address</span>
              <span className="font-medium">{user.email}</span>
            </div>
            <div className="flex justify-between py-2 border-b">
              <span className="text-secondary-600">Phone Number</span>
              <span className="font-medium">
                {user.phone_number || "Not provided"}
              </span>
            </div>
          </div>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <h3 className="text-lg font-semibold mb-4 text-secondary-900">
            Professional Information
          </h3>
          <div className="space-y-4">
            <div className="flex justify-between py-2 border-b">
              <span className="text-secondary-600">Specialization</span>
              <span className="font-medium">
                {user.specialization || "Not specified"}
              </span>
            </div>
            <div className="flex justify-between py-2 border-b">
              <span className="text-secondary-600">Country</span>
              <span className="font-medium">
                {user.country || "Not specified"}
              </span>
            </div>
            <div className="flex justify-between py-2 border-b">
              <span className="text-secondary-600">User Role</span>
              <Chip label={user.role} color="primary" size="small" />
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default PersonalInfoTab;
